




























import Vue from 'vue'

export default Vue.extend({
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    isLiked (): boolean {
      return !!(this.place && this.$store.state.likedPlaces.includes(this.place.id))
    },
    isListingConfirmed (): boolean {
      return !!(this.place && this.place.listing_confirmed)
    }
  }
})
